import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const P404 = r => require.ensure([], () => r(require('../views/commons/404')))
const Login = r => require.ensure([], () => r(require('../views/commons/login')))
const Guide_StationList = r => require.ensure([], () => r(require('../views/power/commons/station_list')))
const Hnac_largeScreen = r => require.ensure([], () => r(require('../views/power/commons/hnac_largeScreen')))


const router = new VueRouter({
    //mode: 'history',
    // base: __dirname,
    routes: [
        // {path: '/', component: Layout, children: pageRoutes},
        { path: '/login', component: Login, hidden: true },  
        { path: '/stationlist', component: Guide_StationList, hidden: true},
        { path: '/hnac_largeScreen', component: Hnac_largeScreen, hidden: true},
        { path: '*', component: P404, hidden: true }
    ]
})


export default router;


// WEBPACK FOOTER //
// ./src/router/index.js